export default {"src":"/_next/static/media/seatbelt.74bb8fdc.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};